import { render, staticRenderFns } from "./TabelaSelecionarPreco.vue?vue&type=template&id=260be6af&"
import script from "./TabelaSelecionarPreco.vue?vue&type=script&lang=js&"
export * from "./TabelaSelecionarPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports